import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Briefcase from 'react-feather/dist/icons/briefcase.js';

import './Results.scss';

export default class ResultsOffers extends Component {
  static defaultProps = {
    nb: 0,
    className: ''
  };

  static propTypes = {
    nb: PropTypes.number,
    className: PropTypes.string
  };

  render() {
    return (
      <div className="results">
        <Briefcase className="icon icon-user"/>
        <div className="nb text-center">{`${this.props.nb} annonce(s)`}</div>
      </div>
    );
  }
}